import { Injectable } from '@angular/core'; 
import { LocalNotifications } from '@capacitor/local-notifications';
import {DatabaseManagerProvider} from '../storage-manager/database-manager';
import { TranslateService } from '@ngx-translate/core';
/*
  Generated class for the LocalNotificationManagerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LocalNotificationManagerProvider {

  constructor(
      public databaseManagerProvider : DatabaseManagerProvider,
      public translateService : TranslateService) {
  }
  initLocalNotifications(){
//       LocalNotifications.cancel({notifications:{}}).then(value=>{
// //          this.setNotoficationToUseApp();
// //      this.setNotificationForOneMinute();
//             this.setNotoficationToUseApp();
//         })

//      this.setEveryMinuteNotification();
//      this.setNotificationForOneMinute();
  }
  async updateLeitnerNotificationsSchedule(){
//       LocalNotifications.cancel({notifications:(await LocalNotifications.getPending())}).then(()=>{
//         this.databaseManagerProvider.getFutureMessages().then(messages=>{
// //                      let msgText = "Time to remember your words in leitner like ";
//         this.translateService.get('NOTIFICATIONS.Leitner.remember').subscribe(
//           value => {
//             // value is our translated string
//                 let msgText = value;     
//                           for(let message of messages){ 
//                 message.reviewTime  = this.refineMessageReviewTime(message.reviewTime);
// //                this.logger.debug("message review time", message.reviewTime, "to this",  new Date(message.reviewTime));
//                 msgText+= message.content+"\n"; 
//                 this.localNotifications.schedule({
//                         id: 1,
//                         text: msgText,
//                         led: '00FF99',
//                         trigger: {
//                             at: new Date(message.reviewTime)
//                         },
// //                        at: new Date(new Date().getTime() + 9000),
//                         icon: 'res://img/icon.png',
//               //          sound: isAndroid? 'file://sound.mp3': 'file://beep.caf',
//                         sound: 'file://sound.mp3',
//                         data: { secret:message.messageID }
//                   })
//             }    
      //     }
      //   )
      //   this.setNotoficationToUseApp();

      //   });          
      // })

  }
  refineMessageReviewTime(time : string){
      return time.split(" ")[0]+" 15:16:00";
  }
  setNotoficationToUseApp(){
      
//       this.translateService.get("NOTIFICATIONS.App.remember").subscribe(value=>{
//             this.localNotifications.schedule({
//               id: 300,
//               text: value, 
//               led: '00FF99',
//               trigger: {
//               at: new Date(new Date().getTime() + 210900200),
//               },
// //              at: new Date(new Date().getTime() + 8000),
//     //          foreground : true,
//     //          sound: isAndroid? 'file://sound.mp3': 'file://beep.caf',
//     //          sound: 'file://sound.mp3', 
//               icon: 'file://assets/img/icon.png',
//               smallIcon: 'res://iconfree',
//               data: { secret:"2222" }
//             });  
//       })
//    this.
  }
  setNotificationForOneMinute(){
//     this.localNotifications.schedule({
//           id: 1,
//           text: 'there are new words like سعید',
//           led: '00FF99',
//           trigger: {
//           at: new Date(new Date().getTime() + 9000)
//           },
// //          foreground : true,
// //          sound: isAndroid? 'file://sound.mp3': 'file://beep.caf',
// //          sound: 'file://sound.mp3',
// //          icon: 'assets://img/icon.png',
//           smallIcon: 'res://img/icon.png',
//           data: { secret:"2222" }
//     });
//    this.setEveryMinuteNotification();

  }
  setEveryMinuteNotification(){
      // Schedule delayed notification
        // this.localNotifications.schedule({
        //    text: 'Delayed ILocalNotification',
        //    trigger: {
        //     at: new Date(new Date().getTime() + 16000),
        //     },
        //    led: 'FF0000',
        //    sound: null
        // });
        // this.logger.debug("local notification set for next 3 seconds");
  }
 initLocalNotificationsExamples(){
      // Schedule a single notification
//         this.localNotifications.schedule({
//           id: 1,
//           text: 'Single ILocalNotification',
// //          sound: isAndroid? 'file://sound.mp3': 'file://beep.caf',
//           sound: 'file://sound.mp3',
//           data: { secret:"2222" }
//         });


//         // Schedule multiple notifications
//         this.localNotifications.schedule([{
//            id: 1,
//            text: 'Multi ILocalNotification 1',
// //           sound: isAndroid ? 'file://sound.mp3': 'file://beep.caf',
//            sound: 'file://sound.mp3',
//            data: { secret:"2222" }
//           },{
//            id: 2,
//            title: 'Local ILocalNotification Example',
//            text: 'Multi ILocalNotification 2',
//            icon: 'http://example.com/icon.png'
//         }]);


//         // Schedule delayed notification
//         this.localNotifications.schedule({
//            text: 'Delayed ILocalNotification',
// //           at: new Date(new Date().getTime() + 7200),
//            led: 'FF0000',
//            sound: 'file://sound.mp3',
//         });
  }

}
